module.exports = __webpack_public_path__ + "static/media/home-myLoan.53295cda04bcf7269cc2fac7b647761a.svg";